import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";
import { Package } from "./package";


export class Subscription extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'Subscription' })
    MODELNAME: string;

    @JsonProperty({ type: 'number' })
    amount_paid: number;

    @JsonProperty({ type: 'string' })
    plan_id: string;

    @JsonProperty({ type: 'Package', clazz: Package })
    package: Package;

    @JsonProperty({ type: 'Date' })
    initial_start_date: Date;

    @JsonProperty({ type: 'Date' })
    start_date: Date;

    @JsonProperty({ type: 'Date' })
    renewal_date: Date;

    @JsonProperty({ type: 'Date?' })
    expire_date?: Date;

    @JsonProperty({ type: 'Date?' })
    canceled_date?: Date;
}



// WEBPACK FOOTER //
// ./src/api/models/subscription.ts